module.exports = __webpack_public_path__ + "img/mind_skeleton_time_5.576e7928.png";